/** Ordered least to most severe. The order is load-bearing: see {@link levelSeverity}. */
export const LOG_LEVELS = ['debug', 'info', 'warn', 'error'];
/** Human-facing labels, for consoles and summaries. */
export const LOG_LEVEL_LABELS = {
    debug: 'Debug',
    info: 'Info',
    warn: 'Warning',
    error: 'Error',
};
/**
 * Numeric severity, spaced by ten.
 *
 * The gaps are deliberate: a caller mapping some other library's levels onto
 * these (syslog, pino, Python's `logging`) can land between two of ours without
 * the comparison collapsing.
 */
export function levelSeverity(level) {
    return (LOG_LEVELS.indexOf(level) + 1) * 10;
}
export function isLogLevel(value) {
    return typeof value === 'string' && LOG_LEVELS.includes(value);
}
/** True when `level` is at least as severe as `threshold`. */
export function meetsThreshold(level, threshold) {
    return levelSeverity(level) >= levelSeverity(threshold);
}
//# sourceMappingURL=levels.js.map